import { eventBus, withPlugins, domEvents } from '@spon/plugins';
import Headroom from 'headroom.js';
import toggle from '@/ui/Toggle';

function Header({ node, plugins: { addEvents } }) {
	const searchForm = document.getElementById('search-global');
	const input = document.querySelector('[name="search"]');

	/*
	 *		Headroom
	 */
	const options = {
		offset: 0, // node.offsetHeight,
		tolerance: {
			up: 5,
			down: 0,
		},
	};
	const headroom = new Headroom(node, options);
	headroom.init();

	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.pageYOffset;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';

			headroom.freeze();
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);

			setTimeout(() => headroom.unfreeze(), 1);
		},
	};

	/*
	 *		Search
	 */

	const search = toggle({
		button: document.querySelector('[data-search-trigger]'),
		name: 'search',
		activeClass: 'is-active',
	});

	search.init();

	search.on('open:search', ({ target }) => {
		document.body.classList.add('search-open');
		searchForm.classList.add('is-open');
		target.classList.add('is-open');
		lock.capture();
		setTimeout(() => {
			input.focus();
		}, 1);
	});

	search.on('close:search', ({ target }) => {
		document.body.classList.remove('search-open');
		searchForm.classList.remove('is-open');
		target.classList.remove('is-open');

		setTimeout(() => {
			input.blur();
			input.value = ''; // reset
			searchForm.reset();
		}, 1);
		lock.release();
	});

	/*
	 *		Navigation
	 */
	const nav = toggle({
		button: node.querySelector('.o-burger'),
		name: 'menu',
		activeClass: 'is-active',
	});
	nav.init();
	nav.on('open:menu', ({ target }) => {
		// eventBus.emit('menu:open');
		node.classList.add('is-open');
		target.classList.add('is-open');
		lock.capture();
	});

	nav.on('close:menu', ({ target }) => {
		lock.release();
		eventBus.emit('menu:close');
		node.classList.remove('is-open');
		target.classList.remove('is-open');
	});

	eventBus.on('page:exited', () => {
		search.close();
		nav.close();
	});

	/*
	 *		Functions
	 */

	function onSubmit(event) {
		// If we're empty, don't submit
		if (input.value === '') event.preventDefault();
	}

	function onKeyDown(event) {
		const { keyCode } = event;

		if (keyCode === 27) {
			if (nav.isOpen) nav.close();
			if (search.isOpen) search.close();
		}

		// Enter
		if (document.body.classList.contains('user-is-tabbing') && keyCode === 13) {
			nav.isOpen ? nav.open() : nav.close(); // eslint-disable-line
			search.isOpen ? search.open() : search.close(); // eslint-disable-line
		}
	}

	function navHover(io) {
		if (io) {
			if (!node.classList.contains('show-nav-bg'))
				node.classList.add('show-nav-bg');
		} else if (node.classList.contains('show-nav-bg')) {
			node.classList.remove('show-nav-bg');
		}
	}

	/*
	 *		Events
	 */
	eventBus.on('menu:open', () => headroom.freeze());
	eventBus.on('menu:close', () => setTimeout(() => headroom.unfreeze(), 1));

	eventBus.on('page:exited', () => {
		// headroom.freeze();
		navHover(0);
		node
			.querySelector('#menu-inner')
			.classList.remove('menu:pointer-events-auto');
	});
	eventBus.on('page:entered', () => {
		headroom.unfreeze();
		node.querySelector('#menu-inner').classList.add('menu:pointer-events-auto');
	});

	// Global re-setter, not just for Header
	// device.resize(() => {
	// 	search.close();
	// 	nav.close();
	// 	lock.release();
	// });

	addEvents({
		submit: onSubmit,
		'mouseenter [data-header-nav]': [
			event => {
				event.stopPropagation();

				navHover(1);
			},
			true, // capture value
		],
		'mouseleave [data-header-nav]': [
			event => {
				event.stopPropagation();
				const { target } = event;
				if (!target.dataset.headerNav || !target.closest('[data-header-nav]'))
					navHover(0);
			},
			true, // capture value
		],
	});

	addEvents(window, {
		keydown: onKeyDown,
	});
}

export default withPlugins(domEvents)(Header);


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
